import { render, staticRenderFns } from "./wrong.vue?vue&type=template&id=2916dfd1&scoped=true&"
import script from "./wrong.vue?vue&type=script&lang=js&"
export * from "./wrong.vue?vue&type=script&lang=js&"
import style0 from "./wrong.vue?vue&type=style&index=0&id=2916dfd1&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2916dfd1",
  null
  
)

export default component.exports